// Angular
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// Components
import { SubjectsComponent } from './subjects.component';

/**
 * Routes
 */
const routes: Routes = [
  {path: '', component: SubjectsComponent}
];

/**
 * Subjects Routing Module
 */
@NgModule({
  imports: [
    // Angular
    RouterModule.forChild(routes),
  ],
  exports: [
    // Angular
    RouterModule,
  ]
})
export class SubjectsRoutingModule {
}
